import FieldEditor from "components/FieldEditor";
import { FieldError, BusinessSavings } from "types";
import * as fields from "pages/clientPortfolio/businessClient/businessClientAccounts/businessSavingsFieldDefinitions";
import AccountEditTemplate from "pages/clientPortfolio/businessClient/businessClientAccounts/components/AccountEditTemplate";
import { useEffect, useState } from "react";
import { requiredDateField } from "common/functions";
import { openConfirm } from "components/confirmBox";
export type Props = {
  account: BusinessSavings;
  isSaving: boolean;
  onCancel(): void;
  onSave(account: BusinessSavings): void;
};

function BusinessSavingsForm({ account, onCancel, onSave, isSaving }: Props) {
  const [state, setState] = useState<BusinessSavings>(account);
  const [errors, setErrors] = useState<FieldError[]>([]);

  useEffect(() => {
    errors.length > 0 && checkErrors();
  }, [state]);

  const commonProps = {
    state: state,
    errors,
    setState: (state: BusinessSavings) => {
      setState(state);
    },
  };

  function checkErrors() {
    if (!account) {
      return;
    }
    const errorsArray: FieldError[] = [
      ...requiredDateField(fields.businessSavingsOpenDate, state),
    ];

    if (
      state.closeDate &&
      state.openDate &&
      state.closeDate.toLowerCase() !== "invalid date" &&
      new Date(state.closeDate) < new Date(state.openDate)
    ) {
      let invalidCloseDateErr: FieldError = {
        id: `${fields.businessSavingsCloseDate.id}`,
        label: `${fields.businessSavingsCloseDate.label}`,
        error: "Close Date should be after the Open Date",
      };
      errorsArray.push(invalidCloseDateErr);
    }

    setErrors(errorsArray);
    return errorsArray;
  }

  function onSaveClick() {
    const err = checkErrors();
    if (err?.length === 0) {
      if (
        state.closeDate &&
        state.closeDate.toLowerCase() !== "invalid date" &&
        state.balance &&
        state.balance !== 0
      ) {
        openConfirm({
          title: "Error",
          description: `Account Balance should be $0.00 to close the account`,
          isAlert: true,
        });
      } else {
        onSave({
          ...state,
          isAccountClosed:
            state.closeDate && state.closeDate.toLowerCase() !== "invalid date"
              ? true
              : false,
        });
      }
    }
  }

  return (
    <AccountEditTemplate
      id={`BUSINESS_SAVINGS_${account.accountId}_form`}
      onSaveClick={onSaveClick}
      onCancelClick={onCancel}
      isSaving={isSaving}
      type="Savings"
      accountNumber={account.accountNumber || ""}
      balance={account.balance || 0}
      column1Fields={
        <>
          <FieldEditor<BusinessSavings>
            field={fields.businessSavingsOpenDate}
            {...commonProps}
          />
          <FieldEditor<BusinessSavings>
            field={fields.businessSavingsAccounNumber}
            {...commonProps}
          />
        </>
      }
      column2Fields={
        <>
          <FieldEditor<BusinessSavings>
            field={fields.businessSavingsCloseDate}
            {...commonProps}
          />
          <FieldEditor<BusinessSavings>
            field={fields.businessSavingsBalance}
            {...commonProps}
          />
        </>
      }
    />
  );
}

export default BusinessSavingsForm;
